jQuery(document).ready(function ($) {
  $('.share-icon').on('click', function () {
    var url = $(this).data('url');

    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(url)
        .then(function () {
          alert('Link copied to clipboard!');
        })
        .catch(function (err) {
          console.error('Failed to copy: ', err);
        });
    } else {
      // Fallback if Clipboard API is not supported
      var tempInput = $('<input>');
      $('body').append(tempInput);
      tempInput.val(url).select();
      document.execCommand('copy');
      tempInput.remove();
      alert('Link copied to clipboard!');
    }
  });
});
